import React from 'react';
import { Field } from 'formik';
import { Row, Col, FormGroup, Input, Label, FormFeedback } from 'reactstrap';
import * as dataSeed from '../shared/DataSeed';

export const AlamatNPWP = ({ errors, touched, values, state, props, onValueChange, setFieldValue, handleChange, handleBlur }) => (
    <React.Fragment>
        <Row>
            <Col md="12">
                <FormGroup>
                    <Label>Alamat NPWP<span className="text-danger">*</span></Label>
                    <Input tag={Field} name="NPWPAddress1" bsSize="sm" maxLength={50}
                        className={errors.NPWPAddress1 && touched.NPWPAddress1 ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                    />
                    {errors.NPWPAddress1 && touched.NPWPAddress1 ? (
                        <FormFeedback>{errors.NPWPAddress1}</FormFeedback>
                    ) : null}
                </FormGroup>
            </Col>
            <Col xs="6">
                <FormGroup>
                    <Label>RT<span className="text-danger">*</span></Label>
                    <Input tag={Field} name="NPWPAddressRT" type="number" bsSize="sm" maxLength="3" invalid={errors.NPWPAddressRT && touched.NPWPAddressRT} />
                    {errors.NPWPAddressRT && touched.NPWPAddressRT ? (
                        <FormFeedback>{errors.NPWPAddressRT}</FormFeedback>
                    ) : null}
                </FormGroup>
            </Col>
            <Col xs="6">
                <FormGroup>
                    <Label>RW<span className="text-danger">*</span></Label>
                    <Input tag={Field} name="NPWPAddressRW" type="number" bsSize="sm" maxLength="3" invalid={errors.NPWPAddressRW && touched.NPWPAddressRW} />
                    {errors.NPWPAddressRW && touched.NPWPAddressRW ? (
                        <FormFeedback>{errors.NPWPAddressRW}</FormFeedback>
                    ) : null}
                </FormGroup>
            </Col>
            <Col md="4" xs="6">
                <FormGroup>
                    <Label>Provinsi<span className="text-danger">*</span> </Label>
                    <Field component="select" name="NPWPAddressProvinceId"
                        className={errors.NPWPAddressProvinceId && touched.NPWPAddressProvinceId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        onChange={(e) => onValueChange(e, setFieldValue)}
                    >
                        <option value="">-- Pilih --</option>
                        {props.provinces.map((province, i) =>
                            <option key={i} value={province.Id}>{province.Name}</option>
                        )}
                    </Field>
                    {errors.NPWPAddressProvinceId && touched.NPWPAddressProvinceId ? (
                        <FormFeedback>{errors.NPWPAddressProvinceId}</FormFeedback>
                    ) : null}
                </FormGroup>
            </Col>
            <Col md="4" xs="6">
                <FormGroup>
                    <Label>Kota<span className="text-danger">*</span></Label>
                    <Field component="select" name="NPWPAddressCityId"
                        className={errors.NPWPAddressCityId && touched.NPWPAddressCityId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        onChange={(e) => onValueChange(e, setFieldValue)}
                    >
                        <option value="">-- Pilih --</option>
                        {props.npwpCities ? props.npwpCities.map((city, i) =>
                            <option key={i} value={city.Id}>{city.Name}</option>
                        ) : null}
                    </Field>
                    {errors.NPWPAddressCityId && touched.NPWPAddressCityId ? (
                        <FormFeedback>{errors.NPWPAddressCityId}</FormFeedback>
                    ) : null}
                </FormGroup>
            </Col>

            <Col md="4" xs="6">
                <FormGroup>
                    <Label>Kecamatan<span className="text-danger">*</span></Label>
                    <Field component="select" name="NPWPAddressSubDistrict"
                        className={errors.SubDistrict && touched.SubDistrict ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        onChange={(e) => onValueChange(e, setFieldValue)}
                    >
                        <option value="">-- Pilih --</option>
                        {props.npwpDistricts ? props.npwpDistricts.map((item, i) =>
                            <option key={i} value={item.Name}>{item.Name}</option>
                        ) : null}
                    </Field>
                    {errors.NPWPAddressSubDistrict && touched.NPWPAddressSubDistrict ? (
                        <FormFeedback>{errors.NPWPAddressSubDistrict}</FormFeedback>
                    ) : null}
                </FormGroup>
            </Col>
            <Col md="4" xs="6">
                <FormGroup>
                    <Label>Kelurahan<span className="text-danger">*</span></Label>
                    <Field component="select" name="NPWPAddressVillage"
                        className={errors.NPWPAddressVillage && touched.NPWPAddressVillage ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        onChange={(e) => onValueChange(e, setFieldValue)}
                    >
                        <option value="">-- Pilih --</option>
                        {props.npwpSubDistricts ? props.npwpSubDistricts.map((item, i) =>
                            <option key={i} value={item.Name}>{item.Name}</option>
                        ) : null}
                    </Field>
                    {/* <Input tag={Field} name="Village" bsSize="sm" invalid={errors.Village && touched.Village} />*/}
                    {errors.NPWPAddressVillage && touched.NPWPAddressVillage ? (
                        <FormFeedback>{errors.NPWPAddressVillage}</FormFeedback>
                    ) : null}
                </FormGroup>
            </Col>

            <Col md="4" xs="6">
                <FormGroup>
                    <Label>Negara<span className="text-danger">*</span></Label>
                    <Field component="select" name="NPWPAddressCountry" disabled={true}
                        className={errors.NPWPAddressCountry && touched.NPWPAddressCountry ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                    >
                        <option value="">-- Pilih --</option>
                        <option value="ID" selected>Indonesia</option>
                    </Field>
                    {errors.NPWPAddressCountry && touched.NPWPAddressCountry ? (
                        <FormFeedback>{errors.NPWPAddressCountry}</FormFeedback>
                    ) : null}
                </FormGroup>
            </Col>
            <Col md="4" xs="6">
                <FormGroup>
                    <Label>Kode Pos<span className="text-danger">*</span></Label>
                    <Input tag={Field} type="tel" maxLength="5" name="NPWPAddressPostalCode" bsSize="sm" readOnly
                        invalid={errors.NPWPAddressPostalCode && touched.NPWPAddressPostalCode}
                    />
                    {errors.NPWPAddressPostalCode && touched.NPWPAddressPostalCode ? (
                        <FormFeedback>{errors.NPWPAddressPostalCode}</FormFeedback>
                    ) : null}
                </FormGroup>
            </Col>
        </Row>
    </React.Fragment>
);


// WEBPACK FOOTER //
// ./src/components/AlamatNPWP.js